"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterTransform = void 0;
exports.filter = filter;
var _nodeStream = require("node:stream");
class FilterTransform extends _nodeStream.Transform {
  constructor(filterFn, options = {}) {
    super({
      objectMode: true,
      ...options
    });
    this.filterFn = filterFn;
  }
  _transform(chunk, _encoding, callback) {
    try {
      if (this.filterFn(chunk)) {
        this.push(chunk);
      }
      callback();
    } catch (error) {
      callback(error);
    }
  }
}
exports.FilterTransform = FilterTransform;
function filter(callback) {
  return new FilterTransform(callback);
}